<template>
    <component :is="props.viewType === ViewTypeOrderBuddy.DROPDOWN ? ExtraDropdownItem : ExtraItemsWrapper" v-bind="props" />
</template>

<script setup lang="ts">
    import type { ExtrasProps } from '~/types/local-types'
    // TODO: if there is an extra where the min and max is the same but there is only 1 option in the list, then it should be checked by default and not modifyable anymore
    import ExtraDropdownItem from '~/components/Extra/ExtraDropdownItem.vue'
    import ExtraItemsWrapper from '~/components/Extra/ExtraItemsWrapper.vue'
    import { ViewTypeOrderBuddy } from '~/types/orderbuddy-types'
    const props = defineProps<ExtrasProps>()
</script>
